/**
 * How many boats one account may keep as favorites.
 *
 * Hardcoded, and enforced in the client only — `POST /favorites` will accept the hundred-and-first.
 * That makes this a guard rail rather than a guarantee: it stops a normal user running the list
 * away with them, and it is not something to rely on for anything that matters.
 *
 * It lives here, beside the favorites API rather than in the app, because that is where it will
 * stop being a constant. When the limit becomes a property of the user's plan it will arrive on a
 * response, and every reader already imports it from this module.
 */
export const FAVOURITE_BOATS_LIMIT = 100;

/** True once the account is holding as many favorites as it is allowed. */
export const isAtFavouriteLimit = (favoriteCount: number): boolean => favoriteCount >= FAVOURITE_BOATS_LIMIT;
